import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  padding: 1rem;
`;

export const StyledLabel = styled.span`
  color: ${pickThemeColor('GRAPHITE_GREY')};
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
`;

export const StyledBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledText = styled.span`
  color: ${pickThemeColor('BLACK')};
  ${pickThemeFontStyles('16', '20', 'NORMAL')};
`;
